import React from "react";
import Link from "gatsby-link";
import Container from "./container";
import SectionHeading from "./section-heading";

const ProjectItem = ({ 
  customClassName, 
  name, title, realURL, 
  desc, path, url 
}) => (
  <div id={path} className={`project-item ${customClassName}`}>
    <Container>
        <div className="project-item-content">
          <h4>{name}</h4>
          <h3>{title}</h3>
          <p>{desc}</p>
          {url ? 
            <Link to={url}>
              <div className="button-purple">
                Read More
              </div>
            </Link> 
          : null}        
        </div>

        <div className="project-item-icon">
          <a href={realURL} target="_blank">
            <img src={`/static/${path}.png`} />
          </a>
        </div>

        
    </Container>
  </div>
);

const HomepageProjects = props => (
  <div className="homepage-projects">
    <Container>
      <SectionHeading
        title="Manifesting Genius Through Innovative Strategies"
        description="Housing a great amount of international businesses allowed us to generate a high number of projects that speak volumes and transform markets. We break the boarders of comfort zone by tempting the levels of probability. We believe that growth is only a result of well calculated risk. Fueled by the urge for expansion and progress, we create products which are beneficial for developers, clients and business people in general. Here are some of our projects and we are not stopping there."
        small={true}
      />
    </Container>

    {props.projects.map((project, idx) => {
      const css = idx % 2 === 0 ? "default-project" : "alternate-project";
      return <ProjectItem customClassName={css} {...project} />
    })}

  </div>
);

export default HomepageProjects;



// WEBPACK FOOTER //
// ./src/components/homepage-projects.js